export const LIGHT_BOX_CONTENT = {
  CLICK_INSIDE: 'interes',
  CLICK_OUTSIDE: 'cerrar-out',
  CLICK_CLOSE: 'cerrar',
}

export const CUSTOM_LINK_CONTENT = {
  DEFAULT: 'link',
}

export const BUTTON_CONTENT = {
  DEFAULT: 'button',
  CONFIRM_PURCHASE: 'confirmar-pedido',
  CTA: 'interes',
}

export const PILL_CONTENT = {
  DEFAULT: 'pill',
}

export const CALL_4_SELLING_CONTENT = {
  C2C: 'te-llamamos',
  T900: 'llama-gratis'
}
